<div #origin="cdkOverlayOrigin" cdkOverlayOrigin>
  @if (isInputView) {
    <nimbus-filter-summary-input
      [summary]="summary"
      [disabled]="disabled"
      [filterName]="filter.name"
      [ngControl]="ngControl"
      [inputValidator]="inputValidator"
      [warningMessage]="warningMessage"
      (summaryClick)="onSummaryClick()"
      (removeFilter)="onRemoveFilter()"
    ></nimbus-filter-summary-input>
  } @else {
    <nimbus-filter-summary-button
      [summary]="summary"
      [filterName]="filter.name"
      [disabled]="disabled"
      [isValueEmpty]="isValueEmpty"
      (summaryClick)="onSummaryClick()"
      (removeFilter)="onRemoveFilter()"
    ></nimbus-filter-summary-button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlayPanelClass="nimbus-filter-select-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  [cdkConnectedOverlayWidth]="overlayWidth"
  (detach)="onDetach()"
  (attach)="onAttach(overlay)"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div #filterOverlay class="nimbus-tooltip-complex flex-container tooltip-content">
    <nimbus-filter-hierarchy-select-list
      [options]="filter.options"
      [focusable]="false"
      [selectedOptions]="filterValue"
      (selectionChanged)="onSelectionChanged($event)"
    ></nimbus-filter-hierarchy-select-list>
  </div>
</ng-template>
